<template>
  <div>
    <breadcrumbs :crumbs="[]">
      <div class="folders-breadcrumbs">
        <a @click="goToFolder(path[0].id)">Reports</a>
        <template v-for="(breadcrumb, idx) in path">
          <a class="folder-path-link" @click="goToFolder(breadcrumb.id)" v-if="idx > 0">
            <i class="fa" :class="{'fa-folder-o' : idx !== path.length-1, 'fa-folder-open-o' : idx === path.length-1 }"></i>{{ breadcrumb.name }}</a><i v-if="idx !== path.length-1" class="fa fa-angle-right"></i>
        </template>
      </div>
    </breadcrumbs>

    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase">Reports</span>
                </div>
              </div>
              <div class="portlet-body">
                <div v-if="user.access > 3">
                  <router-link :to="{ name: 'Reports Add' }" tag="button" class="btn green">Add New Report</router-link>
                  <a class="btn green" @click="showModal('createFolder')">Add New Folder</a>
                </div>

                <div class="form-body" :class="{loading: loading.list}">
                  <spinner v-if="loading.list"/>
                  <div class="vgt-responsive">
                    <table class="vgt-table bordered">
                      <thead>
                      <tr>
                        <th v-for="col in columns"
                            :class="{
                              'cell-actions': col.field === 'action',
                              'sortable sorting': col.field !== 'action',
                              'sorting-asc': sortBy === col.field && sortDir === 'asc',
                              'sorting-desc': sortBy === col.field && sortDir === 'desc',
                        }">
                          <span>{{ col.label }}</span>
                          <button @click="sort(col.field)" v-if="col.field !== 'action'">
                            <span class="sr-only">
                              Sort table by Status in descending order
                            </span>
                          </button>
                        </th>
                        <th rowspan="2">Top 5<br/>Reports</th>
                      </tr>
                      <tr>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Name" class="vgt-input" @change="filter('name', $event)"></div>
                        </th>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Description" class="vgt-input" @change="filter('description', $event)"></div>
                        </th>
                        <th class="filter-th"></th>
                        <th class="filter-th">
                          <div><input type="text" placeholder="Filter Created By" class="vgt-input" @change="filter('user', $event)"></div>
                        </th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                        <th class="filter-th"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="parentFolder" class="folder" :class="'folder'+parentFolder.id" draggable="true" @dragstart.prevent @dragenter="dragEnter" @dragleave="dragLeave" @dragover="dragOver(parentFolder.id, 'folder', $event)">
                        <td colspan="8"><a @click.prevent="goToFolder(parentFolder.id)"><i class="fa fa-level-up dark"></i> ... </a></td>
                      </tr>
                      <tr v-for="row in folders" class="folder" :class="'folder'+row.id" draggable="true" @dragstart.stop="dragStart(row.id, 'folder', $event)" @dragover="dragOver(row.id, 'folder', $event)" @dragenter="dragEnter" @dragleave="dragLeave" @dragend="dragEnd(row.id, 'folder', $event)" @drop="dragFinish(row.id, $event)">
                        <td colspan="7" class="folder">
                          <a @click.prevent="goToFolder(row.id)"><i class="fa fa-folder-o dark"></i>&nbsp; {{row.name}}</a>
                        </td>
                        <td>
                          <div class="last-dropdown">
                            <div class="btn-group">
                              <button class="btn btn-xs green dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"> Actions
                                <i class="fa fa-angle-down"></i>
                              </button>
                              <ul class="dropdown-menu" role="menu">
                                <li>
                                  <a @click.prevent="showEditFolderModal(row.id, row.name)"><i class="fa fa-pencil-square-o"></i> Edit</a>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showModal('moveToFolder', {type: 'folder', id: row.id})">
                                    <i class="fa fa-arrows"></i> Move </a>
                                </li>
                                <li class="divider" v-if="user.access > 3"></li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showModal('deleteFolder', row.id)">
                                    <i class="fa fa-trash"></i> Delete
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                        <td>

                        </td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr v-for="row in rows" v-if="reports.length" class="item" draggable="true" @dragstart.stop="dragStart(row.id, 'item', $event)" @dragover="dragOver(row.id, 'report', $event)" @dragenter="dragEnter" @dragleave="dragLeave" @dragend="dragEnd(row.id, 'report', $event)" @drop="dragFinish(row.id, $event)">
                        <td>
                          <router-link :to="{ name: 'Reports Preview', params: { reportid: row.id } }" tag="a">{{ row.name }}</router-link>
                        </td>
                        <td>{{row.description}}</td>
                        <td class="vgt-text-nowrap">{{ [2, 4].includes(row.mode) ? 'Multiple Organizations' : 'Single Organization' }}</td>
                        <td class="vgt-text-nowrap">{{row.user}}</td>
                        <td>{{row.created_date.date | formatDate}}</td>
                        <td>
                          <template v-if="row.modified_date !== null">{{row.modified_date.date | formatDate}}</template>
                        </td>
                        <td>{{ (row.status == 1 ) ? 'Published' : 'Unpublished' }}</td>
                        <td class="cell-action">
                          <div class="last-dropdown">
                            <div class="btn-group">
                              <button class="btn btn-xs green dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"> Actions
                                <i class="fa fa-angle-down"></i>
                              </button>
                              <ul class="dropdown-menu" role="menu">
                                <li v-if="user.access > 3 && !row.parent_id">
                                  <router-link :to="{ name: 'Reports Edit', params: { reportid: row.id } }" tag="a">
                                    <i class="fa fa-pencil-square-o"></i> Edit
                                  </router-link>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="changeStatusAction(row.id)">
                                    <i class="fa fa-eye"></i> Publish / Draft </a>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showModal('duplicate', row.id)">
                                    <i class="fa fa-files-o"></i> Duplicate </a>
                                </li>
                                <li v-if="user.access > 3">
                                  <a @click.prevent="showModal('moveToFolder', {type: 'report', id: row.id})">
                                    <i class="fa fa-arrows"></i> Move </a>
                                </li>
                                <li>
                                  <a @click.prevent="exportReport(row.id, row.count)">
                                    <i class="fa fa-file-o"></i> Export
                                  </a>
                                </li>
                                <li class="divider" v-if="user.access > 3 && !row.parent_id"></li>
                                <li v-if="user.access > 3 && !row.parent_id">
                                  <a @click.prevent="showDeleteReportModal(row.id)">
                                    <i class="fa fa-trash"></i> Delete
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                        <td>
                          <label class="mt-checkbox mt-checkbox-outline">
                            <input type="checkbox" :value="row.id" @change.prevent="selectTopReport(row.id)" :checked="topReportsIds.includes(row.id)" :disabled="topReportsIds.length >= 5 && !topReportsIds.includes(row.id)"/>
                            <span></span>
                          </label>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="vgt-wrap__footer vgt-clearfix">
                    <template v-if="!reports.length">
                      <h4>Sorry, no results were found.</h4>
                    </template>
                    <template v-if="reports.length">
                      <div class="footer__row-count vgt-pull-left"><span class="footer__row-count__label">Rows per page</span>
                        <select autocomplete="off" name="perPageSelect" class="footer__row-count__select" @change="changePerPage">
                          <option v-for="option in perPageSelectOptions" :selected="perPage === option" :value="option">
                            {{ option === 0 ? 'All' : option }}
                          </option>
                        </select>
                      </div>
                      <div class="footer__navigation vgt-pull-right">
                        <a @click="prevPage()" tabindex="0" class="footer__navigation__page-btn" :class="{ 'disabled': currentPage == 0 }">
                          <span class="chevron left"></span><span>Prev</span>
                        </a>
                        <div class="footer__navigation__info">{{(reportsCount ? currentPage * perPage + 1 : 0)}} - {{visibleRowsCount}} of {{ reportsCount }}</div>
                        <a @click="nextPage()" tabindex="0" class="footer__navigation__page-btn" :class="{ 'disabled': (this.perPage * this.currentPage + this.perPage + 1 > this.reportsCount) || (this.reportsCount <= perPage) || perPage === 0 }"><span>Next</span>
                          <span class="chevron right"></span>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>

                <router-link :to="{name: 'Top 5 Reports List'}" class="view-top-reports btn default pull-right">View Top 5 Reports</router-link>
                <button class="save-top-reports btn green pull-right" @click="saveTopReports">Save Top 5 Reports</button>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <confirmation-modal id="delete-report-modal"
                          title="DELETE REPORT"
                          question="Are you sure you would like to delete this Report?"
                          @confirmed="deleteReportAction(currentModal)"/>
      <duplicate-report-modal v-model="showModalMap.duplicate"
                              :report-id="currentModal"
                              @save="getReportsAction({type: 'report'})"/>
      <create-folder-modal v-model="showModalMap.createFolder"/>
      <delete-folder-modal v-model="showModalMap.deleteFolder"
                           :folder-id="currentModal"/>
      <edit-folder-modal v-model="showModalMap.editFolder"
                         :folder-id="currentModal"
                         :folder-name="editFolderName"/>
      <move-to-folder-modal v-model="showModalMap.moveToFolder"
                            :element-id="currentModal && currentModal.id"
                            :element-type="currentModal && currentModal.type"/>
      <export-modal v-if="showExportModal"
                    :report-id="exportReportId"
                    :result-total-rows="exportTotalRows"
                    v-on:display="showExportModal = $event"/>
    </div>

    <div class="clearfix"></div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from 'vuex';
  import ExportModal from "./ExportModal";
  import DuplicateReportModal from '@/components/modals/reports/DuplicateReportModal';
  import CreateFolderModal from '@/components/modals/reports/CreateFolderModal';
  import EditFolderModal from '@/components/modals/reports/EditFolderModal';
  import DeleteFolderModal from '@/components/modals/reports/DeleteFolderModal';
  import MoveToFolderModal from '@/components/modals/reports/MoveToFolderModal';
  import ConfirmationModal from "@/components/modals/ConfirmationModal";

  export default {
    data() {
      return {
        name: '',
        description: '',
        currentModal: '',
        showModalMap: {
          duplicate: false,
          createFolder: false,
          deleteFolder: false,
          editFolder: false,
          moveToFolder: false,
        },
        editFolderName: '',
        currentPage: 0,
        perPage: 10,
        columns: [
          {label: 'Name', field: 'name'},
          {label: 'Description', field: 'description'},
          {label: 'Report Type', field: 'mode'},
          {label: 'Created By', field: 'user'},
          {label: 'Created On', field: 'created_date.date'},
          {label: 'Modified On', field: 'modified_date.date'},
          {label: 'Status', field: 'status'},
          {label: 'Action', field: 'action'},
        ],
        perPageSelectOptions: [10, 25, 50, 100, 0],
        foldersList: [],
        reportsList: [],
        dragItem: {},
        dropToItem: {},
        sortBy: '',
        sortDir: 'asc',
        filterFields: [],
        topReportsIds: [],
        exportReportId: null,
        exportTotalRows: 0,
        showExportModal: false
      }
    },
    inject: {
      $validator: '$validator'
    },
    components: {
      ExportModal,
      Breadcrumbs,
      Spinner,
      CreateFolderModal,
      DeleteFolderModal,
      EditFolderModal,
      DuplicateReportModal,
      MoveToFolderModal,
      ConfirmationModal,
    },
    mounted() {
      this.currentPage = 0;
      if (this.getFolder !== null && this.$route.params.reset === true) {
        this.setFolderIdAction(null);
        this.$router.push({'name': 'Reports Index'});
      }
      this.getReportsAction({type: 'report'});
    },
    computed: {
      ...mapGetters({
        reports: 'getReports',
        user: 'getUser',
        folders: 'getFolders',
        folder: 'getFolder',
        path: 'getPath',
        parentFolder: 'getParentFolder',
        accountFolders: 'getAccountFolders',
        reportsCount: 'getReportsCount',
        topReportsIdsServer: 'getTopReportsIds',
        loading: 'getReportsLoading'
      }),
      visibleRowsCount() {
        if (this.reportsCount < this.perPage || this.perPage === 0) {
          return this.reportsCount;
        }

        if (this.perPage * this.currentPage + this.perPage > this.reportsCount) {
          return this.reportsCount;
        }

        return (this.perPage * this.currentPage + this.perPage)
      },
      rows() {
        if (this.perPage === 0) {
          return this.reports;
        }

        let items = this.reports;

        if (this.filterFields.length) {
          _.forEach(this.filterFields, function (filter) {
            items = _.filter(items, function (item) {
              return item[filter.field].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
            })
          });
        }

        if (this.sortBy !== '') {
          if (this.sortBy.includes('.date')) {
            let sortBy = this.sortBy.slice(0, -5);
            items = _.orderBy(items, function (item) {
              return item[sortBy] !== null ? item[sortBy].date : new Date(-8640000000000000).toISOString();
            }, [this.sortDir]);
          } else {
            items = _.orderBy(items, [sort => sort[this.sortBy].toString().toLowerCase()], [this.sortDir]);
          }
        }

        return items.slice(this.currentPage * this.perPage, (this.currentPage * this.perPage) + this.perPage);
      },
    },
    methods: {
      ...mapActions({
        getReportsAction: 'GET_REPORTS_LIST_ACTION',
        deleteReportAction: 'DELETE_REPORT_ACTION',
        changeStatusAction: 'CHANGE_STATUS_REPORT_ACTION',
        downloadReport: 'GENERATED_REPORT_ACTION',
        moveToFolderAction: 'MOVE_TO_FOLDER_ACTION',
        setFolderIdAction: 'SET_FOLDER_ID_ACTION',
        saveTopReportsAction: 'SAVE_TOP_REPORTS_ACTION',
      }),
      showModal(type, id = ''){
        this.currentModal = id;
        this.showModalMap[type] = true;
      },
      showDeleteReportModal(id) {
        this.currentModal = id;
        $('#delete-report-modal').modal('show');
      },
      downloadReportType(id, type) {
        this.downloadReport({id: id, from: '', to: '', timezone: this.user.time_zone, token: localStorage.getItem('id_token'), format: type})
      },
      showEditFolderModal(id, name) {
        this.editFolderName = name;
        this.showModal('editFolder', id);
      },
      goToFolder(folderId) {
        this.currentPage = 0;
        this.setFolderIdAction(folderId);
        this.getReportsAction({type: 'report'});
      },
      changePerPage(event) {
        this.perPage = parseInt(event.target.value);
        this.currentPage = 0;
      },
      prevPage() {
        if (this.currentPage === 0) {
          return;
        }
        this.currentPage--;
      },
      nextPage() {
        if (this.perPage * this.currentPage + this.perPage >= this.reportsCount
          || this.perPage === 0) {
          return;
        }
        this.currentPage++;
      },
      sort(field) {
        if (field !== 'action') {
          if (this.sortBy === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
          } else {
            this.sortDir = 'asc';
            this.sortBy = field;
          }
        }
      },
      dragStart(id, type, event) {
        this.dragging = id;
        this.dragItem = {
          id: id,
          type: type
        };
        $(event.target).closest('tr').addClass('draggingItem');
      },
      dragEnter(event) {
        $(event.target).parent('tr').addClass('dragOver');
        $(event.target).parent('tr').siblings('.item').addClass('dragDisabled');
        if ($(event.target).hasClass('folder')) {
          $('tr.item').addClass('dragDisabled');
        }
      },
      dragLeave(event) {
        $(event.target).parent('tr').removeClass('dragOver');
      },
      dragEnd(id, type, event) {
        $('.folder').removeClass('draggingItem');
        $('.item').removeClass('dragDisabled draggingItem');
        if (this.dropToItem.type === 'folder') {
          this.moveToFolderAction({'itemType': type, 'itemId': id, 'folderId': this.dropToItem.id});
          this.dropToItem = {};
        }
        this.dragging = -1
      },
      dragFinish(id, type, ev) {
      },
      dragOver(id, type, ev) {
        this.dropToItem = {
          id: id,
          type: type
        }
      },
      filter(field, event) {
        this.filterFields = _.filter(this.filterFields, function (item) {
          return item.field != field;
        });
        if (event.target.value === '') {
          return
        }
        this.filterFields.push({field: field, value: event.target.value});
      },
      selectTopReport(reportId) {
        let maxIds = this.topReportsIds.length >= 5;
        let idx = this.topReportsIds.indexOf(reportId);

        if (idx !== -1) {
          this.topReportsIds.splice(idx, 1);
        }

        if (idx === -1 && !maxIds) {
          this.topReportsIds.push(reportId)
        }
      },
      saveTopReports() {
        this.saveTopReportsAction({reportsIds: this.topReportsIds});
      },
      exportReport(reportId, rowsCount) {
        this.exportReportId = reportId;
        this.exportTotalRows = rowsCount;
        this.showExportModal = true;
      }
    },
    watch: {
      topReportsIdsServer: function () {
        this.topReportsIds = this.topReportsIdsServer;
      }
    }
  }
</script>

<style scoped>
  .last-dropdown {
    width: auto;
  }

  .vgt-table {
    margin-top: 1em;
  }

  .dropdown-menu {
    min-width: initial;
  }

  .vgt-table tbody + tbody {
    display: table-row-group;
  }

  .dark {
    color: #606266;
  }

  .dragOver {
    background: #ddd;
  }

  .item.dragOver {
    background: #fff;
  }

  .draggingItem {
    border: 1px #ccc solid;
    background: #eee;
  }

  .dragDisabled {
    opacity: 0.5;
  }

  .form-body {
    position: relative;
  }

  .form-body.loading .vgt-responsive {
    opacity: 0.5;
  }

  .form-body .spinner {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
  }

  .save-top-reports, .view-top-reports {
    margin-top: 1em;
    margin-left: 3px;
    color: #333333;
  }

  .cell-action {
    overflow: visible;
  }

  .vgt-responsive {
    overflow: visible;
  }

  @media (max-width: 767px) {
    .vgt-table-responsive .dropdown-menu {
      position: static !important;
    }

    .dropdown-backdrop {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// ReportsList.vue?27423ad4